<template>
  <div>
    <Form @submit="onBeforeSubmit" :validation-schema="validationSchema" :initial-values="formValues">
      <div class="form-header">
        <span class="uk-text-bold uk-text-large">パスワード変更</span>
      </div>
      <div class="uk-modal-body">
        <FormError :errors="globalErrors" />
        <div class="field">
          <Field name="username" v-slot="{ field }">
            <FieldLabel title="ユーザーID" :required="true" />
            <input class="uk-input" type="text" v-bind="field" readonly="true" />
          </Field>
          <FieldError name="username" />
        </div>
        <div class="field">
          <Field name="oldpassword" v-slot="{ field }">
            <FieldLabel title="現在のパスワード" :required="true" />
            <input class="uk-input" :type="inputLock ? 'password' : 'text'" v-bind="field" autocomplete="new-password" />
            <span class="input-icon" :uk-icon="inputLock ? 'icon: lock' : 'icon: unlock'" @click="inputLock = !inputLock"></span>
          </Field>
          <FieldError name="oldpassword" />
        </div>
        <div class="field">
          <Field name="newpassword" v-slot="{ field }">
            <FieldLabel title="新しいパスワード" :required="true" />
            <input
              class="uk-input"
              :type="inputLock ? 'password' : 'text'"
              v-bind="field"
              placeholder="英字（大文字・小文字）、記号、数字を含む"
              autocomplete="new-password"
            />
            <span class="input-icon" :uk-icon="inputLock ? 'icon: lock' : 'icon: unlock'" @click="inputLock = !inputLock"></span>
          </Field>
          <FieldError name="newpassword" />
        </div>
      </div>
      <div class="uk-modal-footer uk-text-right form-action">
        <div>
          <ActionButton title="戻る" width="100" color="default" @click="$emit('close')" />
        </div>
        <div class="form-action-main">
          <ActionButton title="変更" width="120" color="primary" type="submit" :disabled="processing" />
        </div>
      </div>
    </Form>
  </div>
</template>
<style lang="scss" scoped>
@include modal-form;
.form-header {
  margin-bottom: $spacing-medium;
}
.input-icon {
  cursor: pointer;
  position: relative;
  float: right;
  top: -31px;
  right: 10px;
}
</style>
<script lang="ts">
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import FormMixin from "../../helpers/mixins/form";
import { AuthApi } from "../../autogen";
import { Field, Form } from "vee-validate";
import FieldLabel from "../atoms/FieldLabel.vue";
import Store from "../../store";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
type FormValues = {
  username: string;
  oldpassword: string;
  newpassword: string;
  currentUsername: string;
};
@Options({
  components: { Field, Form, FieldLabel, FieldError, ActionButton, FormError }
})
export default class ChangePassword extends FormMixin {
  globalErrors: { message: string }[] = [];
  formValues: FormValues = {
    username: "",
    oldpassword: "",
    newpassword: "",
    currentUsername: ""
  };
  @Prop({ type: Object }) values: { username: string; oldpassword: string } = {
    username: "",
    oldpassword: ""
  };
  inputLock = true;
  beforeMount() {
    if (this.values) {
      this.formValues = Object.assign({ newpassword: "", currentUsername: "" }, this.values);
    }
    const auth = Store.getInstance().getAuth();
    if (auth && auth.user) {
      this.formValues.username = auth!.user.username;
    }
  }
  async onBeforeSubmit(values: FormValues) {
    await this.onSubmit(async () => {
      const auth = Store.getInstance().getAuth();
      if (auth && auth.user) {
        values["currentUsername"] = auth!.user.username;
      }
      await new AuthApi().changePassword({ changePasswordRequest: values });
      this.$emit("submitted", {
        username: values.username,
        password: values.newpassword
      });
    });
  }
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      username: yup.string().required(this.$t("input_required", { field: "ユーザーID" })),
      oldpassword: yup.string().required(this.$t("input_required", { field: "現在のパスワード" })),
      newpassword: yup.string().required(this.$t("input_required", { field: "新しいパスワード" }))
    });
  }
}
</script>
